import {connect} from 'react-redux';
import {getSelectedResidentialAddress} from '../../../../../selectors/selectors';
import AddressAsText from '../../../../address/AddressAsText/AddressAsText';

export default connect(state => ({
  ...getSelectedResidentialAddress(state),
  contactNumber: state.address.deliveryAddressList.contactNumber,
}))(AddressAsText);
